import { Check, Trash2, X } from "lucide-react";
import { useEffect } from "react";
import { getProductImage } from "./product-images";
import { productFrequencyOptions, type ProductFrequency } from "./product-frequency";

type ProductDetailSheetProps = {
  product: string;
  displayName?: string;
  frequency?: ProductFrequency;
  onClose: () => void;
  onToggleFrequency: (frequency: ProductFrequency) => Promise<void> | void;
  onRemove: () => Promise<void> | void;
  labels?: {
    details?: string;
    frequency?: string;
    hint?: string;
    remove?: string;
    close?: string;
  };
  frequencyLabels?: Partial<Record<ProductFrequency, string>>;
};

export default function ProductDetailSheet({ product, displayName, frequency, onClose, onToggleFrequency, onRemove, labels, frequencyLabels }: ProductDetailSheetProps) {
  const detailsLabel = labels?.details === "PRODUCT DETAILS" ? "PRODUCT CATEGORY" : labels?.details ?? "PRODUCT CATEGORY";
  const frequencyLabel = labels?.frequency === "How often do you buy this?" ? "How often do I buy this?" : labels?.frequency ?? "How often do I buy this?";
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [onClose]);

  return <div className="product-detail-sheet" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="product-detail-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="product-detail-title">
      <span className="product-detail-sheet__handle" aria-hidden="true" />
      <button type="button" className="product-detail-sheet__close" onClick={onClose} aria-label={labels?.close ?? "Close product details"}><X /></button>
      <div className="product-detail-sheet__hero">
        <img src={getProductImage(product)} alt="" />
        <div><small>{detailsLabel}</small><h2 id="product-detail-title">{displayName ?? product}</h2></div>
      </div>
      <div className="product-detail-sheet__frequency">
        <strong>{frequencyLabel}</strong>
        <div>{productFrequencyOptions.map((option) => <button type="button" key={option} className={frequency === option ? "active" : ""} aria-pressed={frequency === option} onClick={() => { void onToggleFrequency(option); }}>{frequency === option && <Check />}{frequencyLabels?.[option] ?? option}</button>)}</div>
      </div>
      <button type="button" className="product-detail-sheet__remove" onClick={() => { void onRemove(); }}><Trash2 /> {labels?.remove ?? "Remove product"}</button>
    </section>
  </div>;
}
